import authService from '../services/authService';

export const can = (permissionCode) => {
  const user = authService.getUser();
  if (!user) return false;

  // Project rule: null role means Super Admin
  if (user?.role === null || user?.role === undefined) {
    return true;
  }

  // If role is just an ID → no permissions available
  if (typeof user.role !== 'object') return false;

  const permissions = user.role?.permissions || [];

  return permissions.some(p => p.code === permissionCode);
};

// Pass if user has ANY of the listed permissions
export const canAny = (...perms) => perms.some(p => can(p));

// True only for super admin (role === null)
export const isAdmin = () => {
  const user = authService.getUser();
  if (!user) return false;
  return user?.role === null || user?.role === undefined;
};
